"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TableRowContext_1 = __importDefault(require("./TableRowContext"));
var contexts_1 = require("../../contexts");
var TableContext_1 = __importDefault(require("./TableContext"));
var TableCell = function (props) {
    var formProps = react_1.useContext(contexts_1.FormContext).formProps;
    var isEditing = react_1.useContext(TableRowContext_1.default).isEditing;
    var setEditing = react_1.useContext(TableContext_1.default).setEditing;
    var record = props.record, renderEdit = props.renderEdit, title = props.title, index = props.index, children = props.children;
    var handleEdit = react_1.useCallback(function () {
        if (!(formProps && formProps.dirty)) {
            setEditing(record);
        }
    }, [formProps, record, setEditing]);
    return react_1.useMemo(function () {
        var cell = children;
        if (renderEdit) {
            cell = isEditing ? (renderEdit(title, record, index)) : (react_1.default.createElement("div", { className: "ant-app-editable-cell-value-wrap", style: { paddingRight: 24 }, onClick: handleEdit }, children));
        }
        return react_1.default.createElement("td", { className: "ant-app-table-cell" }, cell);
    }, [isEditing, record, renderEdit, title, index, handleEdit, children]);
};
exports.default = TableCell;
